//  标签搜索

import React from 'react';

import Cache from '../../frame/Cache';
import Config from '../../config/Config';

import WidgetAjax from '../../widget/WidgetAjax';
import WidgetDrawer from '../../widget/WidgetDrawer';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetComponent from '../../widget/WidgetComponent';
import WidgetCondition from '../../widget/WidgetCondition';
import WidgetPageTable from '../../widget/WidgetPageTable';

import EntityDetail from './../EntityDetail';
import '../../css/similar.css';

class similar extends WidgetComponent 
{
    constructor( props ) 
    {
        super(props);

        let basePath = Config.getBasePath();

        let item, oldfilter = {}, confirmValues=[], values = [];

        if (this.props.location !== undefined && this.props.location.state !== undefined) 
        {
            item = this.props.location.state.item;

            if (item !== undefined && item !== null) 
            {
                if (item.CONDITION !== undefined && item.CONDITION !== null && item.CONDITION.definitions !== undefined) 
                {

                    values = item.CONDITION.definitions.values !== undefined ? item.CONDITION.definitions.values : [];

                    confirmValues = [...values];
                }

                if (item.CONDITION !== undefined && item.CONDITION !== null && item.CONDITION.filters !== undefined) 
                {
                    oldfilter = item.CONDITION.filters;
                }
            }
        }


        this.search = this.search.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.pageTurning = this.pageTurning.bind(this);
        this.tableOnEvent = this.tableOnEvent.bind(this);
        this.transformOperations = this.transformOperations.bind(this);

        this.addMonitor = this.addMonitor.bind(this);
        this.addMonitorConfirm = this.addMonitorConfirm.bind(this);
        this.onAddMonitor = this.onAddMonitor.bind(this);

        this.removeMonitor = this.removeMonitor.bind(this);
        this.removeMonitorConfirm = this.removeMonitorConfirm.bind(this);
        this.onRemoveMonitor = this.onRemoveMonitor.bind(this);

        this.addCRM = this.addCRM.bind(this);
        this.addCRMConfirm = this.addCRMConfirm.bind(this);
        this.onAddCRM = this.onAddCRM.bind(this);

        this.removeCRM = this.removeCRM.bind(this);
        this.removeCRMConfirm = this.removeCRMConfirm.bind(this);
        this.onRemoveCRM = this.onRemoveCRM.bind(this);

        this.state = {
            basePath: basePath,
            item: item,

            oldfilter: oldfilter,

            tagValues: values,
            confirmValues: confirmValues,

            keyWord: undefined,

            messageOptions: {
                title: '添加监管'
            },
            drawerOptions: {
                size: 'lg',
                button: false,
            },

            tableOptions: {
                records: 10,
                rowKey: "ENTID",
                isAutoHeight: true,
                checkedKey: "ENTID",
                check: false,
            },
            loading : true,
            total : undefined,
            data :undefined,
            page : 1,
            checkData:[],
            isBatch : false,
            detailData:undefined,
            entityData:undefined,
            columns: [
                [
                    { name: 'ENTID', title: 'ENTID', type: 'string', description: '主体ID', properties: { hidden: true } },
                ],
                [
                    { name: 'ENTID', title: 'ENTID', type: 'string', description: '主体ID', properties: { hidden: true } },
                    { name: 'MONITOR', title: 'MONITOR', type: 'string', description: '监控状态', properties: { hidden: true } },
                    { name: 'ENTNAME', type: 'string', description: '市场主体名称', properties: { hidden: false, click: "entityDetail" } },
                    { name: 'REGSTATE', type: 'string', description: '企业状态', properties: { hidden: false } },
                ],
                [
                    { name: 'TAGS', type: 'string', description: '主体标签', properties: { hidden: false, type: "label" } }
                ],
                [
                    { name: 'DOM', title: '经营地址', type: 'string', description: '经营地址', properties: { hidden: false } },
                    { name: 'INDUSTRYPHY', title: '行业类型', type: 'string', description: '行业类型', properties: { hidden: false } },
                    { name: 'REGCAP', title: '注册资本', type: 'string', description: '注册资本', properties: { hidden: false } },
                    { name: 'ESTDATE', title: '成立时间', type: 'string', description: '成立时间', properties: { hidden: false } }
                ],
                [
                    {
                        name: 'operation', type: 'string', description: '操作', properties: {
                            operations: [
                                { name: '添加监控', click: "addMonitor" },
                                { name: '取消监控', click: "removeMonitor" },

                                { name: '添加CRM', click: "addCRM" },
                                { name: '取消CRM', click: "removeCRM" },

                                // { name: '添加种子企业', click: "addFavor"},
                                // { name: '取消种子企业', click: "removeFavor"},
                            ],
                            transform: "transformOperations"
                        }
                    }
                ]
            ],
            PageTables:true
        };

        this.bindConsole(basePath);
    }


    /** 消息提示框句柄 */
    messageRef = (ref) => {
        this.messageRef = ref;
    }

    /** 企业详情信息抽屉句柄 */
    drawerRef = (ref) => {
        this.drawerRef = ref;
    }


componentDidMount(){
    this.search()
}


    /**
     * 表格数据查询
     * @param {*} page 
     */
    search(page) 
    {
        let { tableOptions, basePath, oldfilter } = this.state, filterType = "AND";

        let filters = {};

        if (page === undefined || page === null || page === "") 
        {
            page = 1;
        }

        let params = {
            schema: "T001001",
            page: page,
            records: tableOptions.records,
            filters: filters,
            filterType: filterType
        }

        WidgetAjax.ajax({ url: basePath + '/report/data', params: params, callback: this.onSearch });

        this.setState({ loading: true, page: page });
    }

    onSearch(result, params) 
    {
        if (result.status === 0) 
        {
            this.setState({ data: result.results, total: result.total, loading: false });
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props)
        }
    }

    /**
     * 表格翻页
     * @param {*}} page 
     */
    pageTurning(page)
     {
        this.search(page);
    }

    /**
     * 表格事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     * @returns 
     */
    tableOnEvent(type, data, value, event) 
    {
        switch (type) 
        {
            // case "transformTEL":
            // {
            //     data = JSON.parse(data);

            //     return this.transformTEL(data, value);
            // }
            case "transformOperations":
            {
                return this.transformOperations(data, value);
            }
            case "entityDetail":
            {

                data = JSON.parse(data);

                this.setState({ detailData: data });

                this.drawerRef.open();

                break;
            }
            case "addMonitor":
            {
                data = JSON.parse(data);

                this.addMonitor(data);

                break;
            }
            case "removeMonitor":
            {
                data = JSON.parse(data);

                this.removeMonitor(data);

                break;
            }
            case "addFavor":
            {
                data = JSON.parse(data);

                this.addFavor(data);

                break;
            }
            case "removeFavor":
            {
                data = JSON.parse(data);

                this.removeFavor(data);

                break;
            }
            case "addCRM":
            {
                data = JSON.parse(data);
                this.addCRM(data);
                break;
            }
            case "removeCRM":
            {
                data = JSON.parse(data);
                this.removeCRM(data);
                break;
            }
            default:
                break;
        }
    }

    /**
     * 表格数据转换
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
    transformOperations(data, content) 
    {
        if (content.props !== undefined && content.props.children !== undefined) 
        {
            for (let i = 0; i < content.props.children.length; i++) 
            {
                let child = content.props.children[i];

                if (child.props.className === "addMonitor") 
                {
                    if (data.MONITOR === true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeMonitor") 
                {
                    if (data.MONITOR !== true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "addCRM") 
                {
                    if (data.CRM === true) {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeCRM") 
                {
                    if (data.CRM !== true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "addFavor")
                {
                    if (data.FAVOR === true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeFavor") 
                {
                    if (data.FAVOR !== true) {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
            }
        }

        return content;
    }

    /**
     * 添加监管
     * @param {*} data 
     */
    addMonitor(data) {

        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.addMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加到监管对象中吗?`;

        messageOptions["title"] = "添加监管";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();

    }

    addMonitors() 
    {

        let { messageOptions, checkData } = this.state, ENTNAMEs = "", isFirst = true;

        messageOptions["isMessage"] = false;

        if (!checkData.length) 
        {
            messageOptions["isMessage"] = true;

            messageOptions["message"] = `请选择需要添加监控的企业`;

            messageOptions["title"] = "添加监控企业";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else 
        {
            for (let item of checkData) 
            {
                if (isFirst === true) {
                    ENTNAMEs = `'` + item.ENTNAME + `'`

                    isFirst = false;
                }
                else {
                    ENTNAMEs += `, '` + item.ENTNAME + `'`
                }
            }

            messageOptions["message"] = `确定要把 '` + ENTNAMEs + `' 加入监控对象吗?`;

            messageOptions['confirmFunction'] = this.addMonitorConfirm;

            messageOptions["title"] = "添加监控";

            this.state['isBatch'] = true;
            this.state['entityData'] = undefined;
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }

    addMonitorConfirm() 
    {
        const { basePath, entityData, isBatch, checkData } = this.state;
        let params = {};

        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params["ENTIDs"] = ENTIDs;
        }
        else 
        {
            params["ENTID"] = entityData.ENTID;
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/add_entity', params: params, callback: this.onAddMonitor, backParam: { data: entityData } });
    }

    onAddMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions, isBatch, checkData } = this.state;

            messageOptions["isMessage"] = true;

            if (isBatch === true) 
            {
                let ENTNAMEs = "", isFirst = true;

                for (let item of checkData) 
                {
                    if (isFirst === true) 
                    {
                        ENTNAMEs = `'` + item.ENTNAME + `'`

                        isFirst = false;
                    }
                    else 
                    {
                        ENTNAMEs += `, '` + item.ENTNAME + `'`
                    }
                }

                if (result.result === checkData.length) 
                {
                    messageOptions["message"] = ENTNAMEs + `' 全部成功加入监控对象中！`;
                }
                else 
                {
                    messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.result + ` 条成功添加监控, 有 ` + (checkData.length - result.result) + ` 条失败!`;
                }
            }
            else 
            {
                messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添加进监控对象中！`;
                this.search(1);
            }

            messageOptions["title"] = "添加监控";

            this.state['entityData'] = undefined;
            this.state['checkData'] = [];
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else if (result.status === 10)
        {
            Cache.logout(this.props);
        }

    }

    /**
     * 取消监管
     * @param {*} data 
     */
    removeMonitor(data) 
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.removeMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 从监管对象中移除吗?`;

        messageOptions["title"] = "取消监管";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();
    }


    removeMonitorConfirm() 
    {
        const { basePath, entityData, isBatch, checkData } = this.state;

        let params = {};

        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params["ENTIDs"] = ENTIDs;
        }
        else 
        {
            params["ENTID"] = entityData.ENTID;
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/remove_entity', params: params, callback: this.onRemoveMonitor, backParam: { data: entityData } });
    }


    onRemoveMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions, isBatch, checkData } = this.state;

            messageOptions["isMessage"] = true;

            if (isBatch === true) 
            {
                let ENTNAMEs = "", isFirst = true;

                for (let item of checkData) 
                {
                    if (isFirst === true) 
                    {
                        ENTNAMEs = `'` + item.ENTNAME + `'`

                        isFirst = false;
                    }
                    else 
                    {
                        ENTNAMEs += `, '` + item.ENTNAME + `'`
                    }
                }

                if (result.result === checkData.length) 
                {
                    messageOptions["message"] = ENTNAMEs + `' 全部成功取消监控！`;
                }
                else 
                {
                    messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.result + ` 条成功取消监控, 有 ` + (checkData.length - result.result) + ` 条失败!`;
                }
            }
            else 
            {
                messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添从监管对象中移除！`;
            }

            messageOptions["title"] = "取消监管";

            this.state['entityData'] = undefined;
            this.state['checkData'] = [];
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            setTimeout(() => { this.props.history.go() }, 1500)
        }
        else if (result.status === 10)
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 添加 CRM
     * @param {*} data 
     */
    addCRM(data) 
    {
        let { messageOptions } = this.state;
        messageOptions["isMessage"] = false;
        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加至CRM中吗?`;
        messageOptions['confirmFunction'] = this.addCRMConfirm;
        messageOptions["title"] = "添加CRM";
        messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    /**
     * 将选中的企业添加进CRM
     */
    addCRMs() 
    {
        let { checkData, messageOptions } = this.state

        if (!checkData.length) 
        {
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `请选择要添加CRM的企业`;
            messageOptions["title"] = "添加CRM";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else 
        {
            let Objs, isFirst = true;

            for (let item of checkData) 
            {
                if (isFirst) 
                {
                    Objs = item.ENTNAME;

                    isFirst = false;
                }
                else 
                {
                    Objs += ", " + item.ENTNAME;
                }
            }

            messageOptions["isMessage"] = false;
            messageOptions['confirmFunction'] = this.addCRMConfirm;
            messageOptions['message'] = `您确定要将 ${Objs} 加入CRM吗?`;
            this.state['messageOptions'] = messageOptions;
            this.state["isBatch"] = true

            this.messageRef.open();
        }
    }

    addCRMConfirm() 
    {
        let { messageOptions, basePath, isBatch, checkData } = this.state, params;
        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params = {
                "ENTIDs": ENTIDs
            }

            WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { checkData } });
        }
        else 
        {
            let data = messageOptions["entData"];

            params = {
                "ENTID": data["ENTID"]
            };

            WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { Name: data.ENTNAME } });
        }
    }

    onAddCRM(result, params, backParam)
    {
        if (result.status === 0) 
        {
            if (backParam.checkData) 
            {
                let { messageOptions } = this.state, isFirst = true, addCRMName = '';

                messageOptions["isMessage"] = true;

                for (let item in backParam.checkData) 
                {
                    if (isFirst) 
                    {
                        addCRMName = backParam.checkData[item].ENTNAME;
                        isFirst = false
                    }
                    else 
                    {
                        addCRMName += ", " + backParam.checkData[item].ENTNAME;
                    }
                }

                let defeatedAdd = backParam.checkData.length - result.result

                messageOptions["message"] = `已将 ${addCRMName} 添加至CRM!  有 ${result.result} 条添加成功， 有 ${defeatedAdd} 条已存在CRM中或添加失败！`;
                messageOptions["title"] = "添加成功";

                this.state['messageOptions'] = messageOptions;
            }
            else 
            {
                let { messageOptions } = this.state;

                messageOptions["isMessage"] = true;
                messageOptions["message"] = `已将 ${backParam.Name} 添加至CRM!`;
                messageOptions["title"] = "添加成功";

                this.state['messageOptions'] = messageOptions;
            }

            this.messageRef.open();
        }
        else if (result === 10) 
        {
            Cache.logout(this.props);
        }
        else if (result.status === -1) 
        {
            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！`;
            messageOptions["title"] = "错误";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }

        this.state["isBatch"] = false
    }


    /**
     * 取消 CRM
     * @param {*} data 
     */
    removeCRM( data )
    {
        let { messageOptions, checkData } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定要将 '` + data.ENTNAME +`' 从CRM中移除吗?` ;
        messageOptions['confirmFunction'] = this.removeCRMConfirm;
        messageOptions["title"] = "移出CRM" ;
        messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    removeCRMConfirm()
    {
        let { messageOptions, basePath } = this.state, 
        data = messageOptions["entData"],
        params = {
            "ENTID":data.ENTID
        };

        WidgetAjax.ajax({url:basePath + '/follow/remove_entity', params:params, callback:this.onRemoveCRM, backParam:{Name:data.ENTNAME}});
    }

    onRemoveCRM( result, params, backParam )
    {
        if( result.status === 0 )
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true ;
            messageOptions["message"] = `已将 ${backParam.Name} 从CRM中移除!` ;
            messageOptions["title"] = "移除成功" ;
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else if( result === 10 )
        {
            Cache.logout(this.props);
        }
        else if( result.status === -1 )
        {
            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！` ;
            messageOptions["title"] = "错误" ;
            this.state['messageOptions'] = messageOptions;
            this.messageRef.open();
        }
    }


    /**
     * 取消CRM
     */
    deleteCRMConfirm() 
    {
        const { checkData, basePath } = this.state

        let OBJIDs = [];

        for (let item of checkData) {
            OBJIDs.push(item.ENTID);
        }

        let params = {
            "ids": OBJIDs
        }
        WidgetAjax.ajax({ url: basePath + '/follow/remove_entity', params: params, callback: this.onDeleteCRM });
    }

    onDeleteCRM(result, params) 
    {
        let { messageOptions } = this.state

        messageOptions["isMessage"] = true;

        if (result.status === 0) 
        {
            messageOptions['message'] = '删除成功'
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        else 
        {
            messageOptions['message'] = '删除失败'
        }
        this.messageRef.open();
    }


    render() 
    {

        const {    
            tableOptions, loading, total, data, page, columns, detailData,
            messageOptions,  drawerOptions,PageTables } = this.state;

        return (
            <div className="page search-tag-wrap page-overflow">
                <div className="page-content page-tag-content" style={{ background: 'none' }}>
                    {/* 企业列表 */}
                    <div className="content-bottom">
                        <div id="contentTagReport" className="content-report content-canvas content-bottom-frame">
                            <div className="content-report" style={{ minHeight: 160 }}>
                                <WidgetPageTable onRef={(ref) => { this.WidgetPageTableRef = ref }} options={tableOptions} columns={columns} data={data} total={total} loading={loading} PageTables={PageTables}
                                    notify={this.tableOnEvent} pageTurning={this.pageTurning} page={page}/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 企业详情 */} 
                <WidgetDrawer options={drawerOptions} onRef={this.drawerRef} >
                    <div className="frame-body">
                        <EntityDetail data={detailData} ></EntityDetail>
                    </div>
                </WidgetDrawer>

                {/* 操作信息提示 */}
                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
            </div>
        )
    }
}

export default similar;

